import { Component, ViewChild } from '@angular/core';
import { nameof } from 'ts-simple-nameof';
import { PagedSearchDto } from '../../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/PagedSearchDto';
import { GridMenuItem } from '../../../../../../libs/utils/ng-shared-components/src/lib/grid/grid-menu/grid-menu-item';
import { GridComponent, IGridActionButton } from '../../../../../../libs/utils/ng-shared-components/src/lib/grid/grid.component';
import { FilterType } from '../../../../../../libs/utils/ng-shared-components/src/lib/grid/interface/filter-type';
import { CellValueType, IGridColumn } from '../../../../../../libs/utils/ng-shared-components/src/lib/grid/interface/grid-column';
import { IGridFilterNumeric } from '../../../../../../libs/utils/ng-shared-components/src/lib/grid/interface/grid-filter';
import { ModalService } from '../../../../../../libs/utils/ng-shared-components/src/lib/services/modal.service';
import { OperationDto } from '../../../api/dtos/OperationDto';
import { OperationFiltersDto } from '../../../api/dtos/OperationFiltersDto';
import { HttpApiRequestOptions } from '../../../api/endpoints/HttpApiRequestOptions';
import { enumName_mi_pspc } from '../../../api/enums/_enumName.mi_pspc';
import { TrackingPopupComponent } from '../../components/track-grid/tracking-popup.component';
import { OperationCreateComponent } from '../operation/operation-create.component';
import { OperationEditComponent } from '../operation/operation-edit.component';
import { OperationDetailsComponent } from './operation-details.component';
import { Icons } from '../../../../../../libs/utils/ng-shared-components/src/lib/icon/icons';
import { OperationStatus } from '../../../api/enums/OperationStatus';
import { ApiOperation } from '../../../api/endpoints/ApiOperation';
import { ApiClientAdminOperation } from '../../../api/endpoints/ApiClientAdminOperation';
import { NavigationService } from '../../../../../../libs/utils/ng-shared-components/src/lib/services/navigation.service';
import { AppRoute } from '../../app.routes.path';
import { FilterEntityType } from '../../view-models/FilterEntityType';
import { ActivatedRoute } from '@angular/router';
import { OperationImportComponent } from './operation-import/operation-import.component';
import { NotificationService } from '../../../../../../libs/utils/ng-shared-components/src';

@Component({
  standalone: false,
  selector: 'mf-operation-grid',
  templateUrl: './operation-grid.component.html',
  styleUrls: ['./operation-grid.component.scss'],
})
export class OperationGridComponent {
  constructor(
    public _apiOperation: ApiOperation,
    public _apiClientAdminOperation: ApiClientAdminOperation,
    private _modalService: ModalService,
    private _activatedRoute: ActivatedRoute,
    private _navigationService: NavigationService,
    private _notificationService: NotificationService
  ) {
    if (this._activatedRoute.snapshot.queryParams.operationNumber) {
      this.filters.operationNumber = this._activatedRoute.snapshot.queryParams.operationNumber;
    }
    if (this._activatedRoute.snapshot.queryParams.externalId) {
      this.filters.externalId = this._activatedRoute.snapshot.queryParams.externalId;
    }
  }

  @ViewChild('grid')
  grid: GridComponent;
  operation: OperationDto;

  filters = new OperationFiltersDto();

  columns: IGridColumn<OperationDto>[] = [
    {
      field: nameof<OperationDto>((o) => o.operationNumber),
      header: 'Número',
      width: 5,
      filter: {
        propertyName: nameof<OperationFiltersDto>((o) => o.operationNumber),
        type: FilterType.Number,
        intOnly: true,
      } as IGridFilterNumeric,
    },
    {
      field: nameof<OperationDto>((o) => o.externalId),
      header: 'Id externo',
      width: 5,
      filter: {
        propertyName: nameof<OperationDto>((o) => o.externalId),
        type: FilterType.Text,
      },
    },
    {
      field: nameof<OperationDto>((o) => o.client.name),
      header: 'Cliente',
      width: 10,
      filter: {
        propertyName: nameof<OperationFiltersDto>((o) => o.client),
        type: FilterType.Entity,
        entityType: FilterEntityType.Client,
      },
    },
    {
      field: nameof<OperationDto>((o) => o.reason),
      header: 'Razón',
      width: 20,
      filter: {
        propertyName: nameof<OperationFiltersDto>((o) => o.reason),
        type: FilterType.Text,
      },
    },
    {
      field: nameof<OperationDto>((o) => o.createdDate),
      header: 'Creada',
      width: 10,
      cellOptions: {
        type: CellValueType.Date,
      },
      filter: {
        propertyName: nameof<OperationFiltersDto>((o) => o.createdDate),
        type: FilterType.Date,
      },
    },
    {
      field: nameof<OperationDto>((o) => o.status),
      header: 'Estado',
      width: 5,
      cellOptions: {
        type: CellValueType.Enum,
        enumName: enumName_mi_pspc.OperationStatus,
      },
      filter: {
        propertyName: nameof<OperationFiltersDto>((o) => o.statusList),
        enumName: enumName_mi_pspc.OperationStatus,
        type: FilterType.EnumList,
      },
    },
    {
      field: nameof<OperationDto>((o) => o.currency),
      header: 'Moneda',
      width: 5,
      cellOptions: {
        type: CellValueType.Enum,
        enumName: enumName_mi_pspc.Currency,
      },
      filter: {
        propertyName: nameof<OperationFiltersDto>((o) => o.currency),
        enumName: enumName_mi_pspc.Currency,
        type: FilterType.Enum,
      },
    },
    {
      field: nameof<OperationDto>((o) => o.amount),
      header: 'Total',
      width: 10,
      cellOptions: {
        type: CellValueType.Numeric,
      },
      filter: {
        propertyName: nameof<OperationFiltersDto>((o) => o.amount),
        type: FilterType.NumericRange,
      },
    },
  ];

  menuItems: GridMenuItem[] = [
    {
      label: 'Abrir operación',
      icon: Icons.openInNew,
      onClick: (operationDto: OperationDto) => {
        this._modalService.openRightModal(OperationEditComponent, {
          openData: {
            operationId: operationDto.id,
          },
          onCloseSuccess: () => {
            this.grid.reloadPage();
          },
          onCloseCancel: () => {
            this.grid.reloadPage();
          },
        });
      },
    },
    {
      label: 'Ver incidentes relacionados',
      icon: Icons.issue,
      onClick: (operationDto: OperationDto) => {
        this._navigationService.navigate(AppRoute.issues, '', { operationBlockedId: operationDto.id });
      },
    },
    {
      label: 'Ver detalles',
      icon: Icons.search,
      onClick: (operationDto: OperationDto) => {
        this._modalService.openRightModal(OperationDetailsComponent, {
          openData: operationDto.id,
          onCloseSuccess: async () => {},
        });
      },
    },
    {
      label: 'Ver tracking',
      icon: Icons.list,
      onClick: (operationDto: OperationDto) => {
        this._modalService.openLargeModal(TrackingPopupComponent, {
          openData: operationDto.id,
          onCloseSuccess: async () => {},
        });
      },
    },
    {
      label: 'Cancelar',
      icon: Icons.delete,
      hide: (operationDto: OperationDto) => operationDto.status >= OperationStatus.Paying || operationDto.status == OperationStatus.Draft,
      onClick: (operationDto: OperationDto) => {
        this._modalService.openYesOrNoModal({
          openData: {
            title: '¿Está seguro de cancelar la operación?',
          },
          onCloseSuccess: async () => {
            const response = await this._apiClientAdminOperation.cancel(operationDto.id);
            if (response.errorMessages.length > 0) {
              this._notificationService.showWarning(response.errorMessages.join('\n'));
            }
            this.grid.reloadPage();
          },
        });
      },
    },
    {
      label: 'Eliminar borrador',
      icon: Icons.delete,
      hide: (operationDto: OperationDto) => operationDto.status != OperationStatus.Draft,
      onClick: (operationDto: OperationDto) => {
        this._modalService.openYesOrNoModal({
          openData: {
            title: '¿Está seguro de eliminar la operación?',
          },
          onCloseSuccess: async () => {
            await this._apiClientAdminOperation.delete(operationDto.id);
            this.grid.reloadPage();
          },
        });
      },
    },
    {
      label: 'Enviar notificación por WebHook',
      icon: Icons.web,
      onClick: async (operationDto: OperationDto) => {
        await this._apiClientAdminOperation.notifyClientWebHook(operationDto.id);
      },
    },
  ];

  gridActionButtons: IGridActionButton[] = [
    {
      text: 'Nueva operación',
      onClick: () => {
        this.openNewOperationPopup();
      },
    },
    {
      text: 'Importar operaciones',
      icon: Icons.upload,
      isSecondary: true,
      onClick: () => {
        this.showUploadModal();
      },
    },
  ];

  apiEndpoint = (search: PagedSearchDto<OperationFiltersDto>, httpApiRequestOptions: HttpApiRequestOptions) =>
    this._apiOperation.getPaged(search, httpApiRequestOptions);

  openNewOperationPopup() {
    this._modalService.openLargeModal(OperationCreateComponent, {
      onCloseSuccess: (operationDto: OperationDto) => {
        this.grid.reloadPage();
      },
      onCloseCancel: (operationDto: OperationDto) => {
        this.grid.reloadPage();
      },
    });
  }

  showUploadModal() {
    this._modalService.openRightModal(OperationImportComponent, {
      onCloseSuccess: (operationDto: OperationDto) => {
        this.grid.reloadPage();
      },
      onCloseCancel: (operationDto: OperationDto) => {
        this.grid.reloadPage();
      },
    });
  }
}
